module.exports = __webpack_public_path__ + "img/login_syqor_logo.8f5932dd.svg";